import { render, staticRenderFns } from "./OrganiserIntroduction.vue?vue&type=template&id=039f582a&scoped=true"
import script from "./OrganiserIntroduction.vue?vue&type=script&lang=js"
export * from "./OrganiserIntroduction.vue?vue&type=script&lang=js"
import style0 from "./OrganiserIntroduction.vue?vue&type=style&index=0&id=039f582a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039f582a",
  null
  
)

export default component.exports